// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
/** Ensure extensions are only requested once */
export function getWebGLExtension(gl, name, extensions) {
    if (extensions[name] === undefined) {
        extensions[name] = gl.getExtension(name) || null;
    }
    return extensions[name];
}
//# sourceMappingURL=webgl-extensions.js.map